
import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';

// This is a summary table from the line_day_actual_track
// total_spent_sec = sum(total_spent_secs) in the line_day_actual_track for all the records for hour + operation + operator ( include rework)
@Entity('t_operator_efficiency_day_track')
export class OperatorEfficiencyDayTrackEntity {
    @PrimaryGeneratedColumn('increment', {
        name:'id'
    })
    id: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'line_id'
    })
    lineId: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'workstation_id',
        default: ''
    })
    workstationId: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'style_id',
        default: ''
    })
    styleId: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'operator_id',
        default: ''
    })
    operatorId: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'operation_id',
        default: ''
    })
    operationId: string;


    @Column('date', {
        nullable: false,
        name: 'plan_date',
    })
    planDate: string;
    
    @Column('tinyint', {
        nullable: false,
        name: 'hour'
    })
    hour: number; // The plant followed hour that deviated only for the 1st hour and the last working hours
    // ex: plant working hours are from 9 - 17:30. In this case any work done before 9.00AM must fall under the hour 9. And any work done after 17:30 must fall under hour 17

    @Column('tinyint', {
        nullable: false,
        name: 'actual_hour'
    })
    actualHour: number; // The hour really at which the operation has been physically took place

    @Column('time', {
        nullable: true,
        name: 'first_trans_in_hour'
    })
    firstTransInHour: string;

    @Column('time', {
        nullable: true,
        name: 'last_trans_in_hour'
    })
    lastTransInHour: string;

    @Column('int', {
        nullable: false,
        name: 'hour_plan_time',
        default: 0
    })
    hourPlannedTime: number; // seconds - planned operation smv * garments planned in that hour

    @Column('int', {
        nullable: false,
        name: 'actual_plan_time',
        default: 0
    })
    actualPlannedTime: number; // seconds - planned operation smv * total no of garments completed for that op with that hour range 

    @Column('int', {
        nullable: false,
        name: 'actual_spent_time',
        default: 0
    })
    actualSpentTime: number; // seconds - sum(hanger out - hanger in) of all the garments completed for that op with that hour range

    @Column('numeric', {
        nullable: false,
        name: 'efficiency',
        default: 0
    })
    efficiency: number; // efficiency in number = actualPlannedTime/actualSpentTime

    @Column('boolean', {
        nullable: false,
        default: false,
        name: 'is_last_op'
    })
    isLastOp: boolean;

    @Column('tinyint', {
        nullable: false,
        name: 'op_order',
        default: 0
    })
    opOrder: number; // efficiency in number


    @Column('varchar',{
        nullable:false,
        length: 10,
        name:'unit_id'
    })
    unitId: string;

    @Column('boolean',{
        nullable:false,
        default: true,
        name:'is_active'
    })
    isActive:boolean;

    @CreateDateColumn({name: 'created_at'})
    createdAt: Date;

    @UpdateDateColumn({name: 'updated_at'})
    updatedAt: Date;
}